import React from "react"
import "./loggedInLayout.scss"
import { Route, Switch } from "react-router-dom"
import {
  ABOUT_US,
  ACCOUNTS_INFO,
  ACCOUNTS_INFO_AGENT,
  ACCOUNTS_INFO_EDUCATOR,
  ACCOUNTS_INFO_LEARNER,
  ACCOUNTS_INFO_ORGANIZATION,
  APP_PROMOTE,
  BOOK_MEET_AUTHORIZED,
  bookmarksRoutes,
  calendarRoutes,
  chatsRoutes,
  CONTACT_FORM,
  friendsRoutes,
  groupsRoutes,
  HOME,
  HOW_TO,
  HOW_TO_FAQ,
  HOW_TO_GENERAL,
  invenstoryRoutes,
  knowcredRoutes,
  knowmapRoutes,
  knowmixRoutes,
  marketplaceRoutes,
  newsRoutes,
  notificationsRoutes,
  PRICING,
  PROMOTE,
  searchRoutes,
  standardsRoutes,
  TERMS_AND_CONDITIONS,
  userRoutes,
} from "../../../library/constants/routes"
import { bindActionCreators } from "redux"
import {
  getData,
  getUserSubscriptions,
  signOut,
} from "../../../library/store/actions/creators/authCreators"
import { connect } from "react-redux"
import HeaderLoggedIn from "../../../components/headerLoggedIn/headerLoggedIn"
import InfoPage from "../../info/infoPage/infoPage"
import LayoutWithSidebar from "./layoutWithSidebar/layoutWithSidebar"
import getErrorText from "../../../library/constants/errorTypes"
import {
  getChatsCount,
  getNotificationCount,
  incrementNotificationCount,
} from "../../../library/store/actions/creators/notificationCreators"
import { wsUrl } from "../../../library/networking/API"
import { withSnackbar } from "notistack"
import AccountsInfoMain from "../../info/accounts/accountsInfoMain"
import AccountsInfoLearner from "../../info/accounts/accountsInfoLearner"
import AccountsInfoEducator from "../../info/accounts/accountsInfoEducator"
import AccountsInfoAgent from "../../info/accounts/accountsInfoAgent"
import AccountsInfoOrganization from "../../info/accounts/accountsInfoOrganization"
import UserCalendarProvider from "../calendar/UserCalendarProvider"

class LoggedInLayout extends React.Component {
  async componentDidMount() {
    try {
      await this.props.getData()
      await this.props.getUserSubscriptions()
      await this.props.getNotificationCount()
      await this.props.getChatsCount()
    } catch ({ error }) {
      if (error.code === 20005) return
      this.props.enqueueSnackbar(getErrorText(error.code), { variant: "error" })
    }
    try {
      this.connectSocket()
    } catch (e) {
      console.error(e)
    }
  }

  connectSocket = () => {
    this.socket = new WebSocket(`${wsUrl}notifications.subscribe`)
    this.socket.onopen = (e) => {
      this.heartbeat()
    }
    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data)
      this.props.incrementNotificationCount(
        data.type,
        data.increment,
        data.chat
      )
    }
  }

  heartbeat = () => {
    if (!this.socket) return
    if (this.socket.readyState !== 1) return
    this.socket.send(
      JSON.stringify({
        token: this.props.auth.userData.token,
      })
    )
    setTimeout(this.heartbeat, 3000)
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close()
      this.socket = null
    }
  }

  render() {
    const props = this.props

    return (
      <UserCalendarProvider>
        <HeaderLoggedIn {...props} />
        <Switch>
          <Route
            exact
            path={[
              HOME,
              ...userRoutes,
              ...newsRoutes,
              ...searchRoutes,
              ...friendsRoutes,
              ...knowcredRoutes,
              ...groupsRoutes,
              ...chatsRoutes,
              ...marketplaceRoutes,
              ...bookmarksRoutes,
              ...standardsRoutes,
              ...notificationsRoutes,
              ...knowmixRoutes,
              ...knowmapRoutes,
            ]}
            component={LayoutWithSidebar}
          />

          <Route
            exact
            path={BOOK_MEET_AUTHORIZED}
            component={LayoutWithSidebar}
          />

          <Route
            exact
            path={invenstoryRoutes}
            render={(props) => (
              <InfoPage {...props} isLoggedIn pageType="invenstory" />
            )}
          />

          <Route
            exact
            path={calendarRoutes}
            render={(props) => <InfoPage {...props} pageType="calendar" />}
          />

          <Route
            exact
            path={TERMS_AND_CONDITIONS}
            render={(props) => (
              <InfoPage {...props} isLoggedIn pageType="terms" />
            )}
          />
          <Route
            exact
            path={CONTACT_FORM}
            render={(props) => <InfoPage {...props} pageType={"feed-back"} />}
          />
          <Route
            exact
            path={APP_PROMOTE}
            render={(props) => (
              <InfoPage {...props} isLoggedIn pageType={"app-promote"} />
            )}
          />
          <Route
            exact
            path={PRICING}
            render={(props) => <InfoPage {...props} pageType={"pricing"} />}
          />
          <Route
            exact
            path={ABOUT_US}
            render={(props) => <InfoPage {...props} pageType={"about-us"} />}
          />
          <Route exact path={ACCOUNTS_INFO} component={AccountsInfoMain} />
          <Route
            exact
            path={ACCOUNTS_INFO_LEARNER}
            component={AccountsInfoLearner}
          />
          <Route
            exact
            path={ACCOUNTS_INFO_EDUCATOR}
            component={AccountsInfoEducator}
          />
          <Route
            exact
            path={ACCOUNTS_INFO_AGENT}
            component={AccountsInfoAgent}
          />
          <Route
            exact
            path={ACCOUNTS_INFO_ORGANIZATION}
            component={AccountsInfoOrganization}
          />
          <Route
            exact
            path={PROMOTE}
            render={(props) => <InfoPage {...props} pageType={"promote"} />}
          />
          <Route
            exact
            path={[HOW_TO, HOW_TO_GENERAL, HOW_TO_FAQ]}
            render={(props) => <InfoPage {...props} pageType={"how-to"} />}
          />
        </Switch>
      </UserCalendarProvider>
    )
  }
}

const mapStateToProps = ({ auth, notifications }) => ({ auth, notifications })
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut,
      getNotificationCount,
      incrementNotificationCount,
      getChatsCount,
      getData,
      getUserSubscriptions,
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(LoggedInLayout))
